import auditLogApi from "../api/auditLog";
import { formatUTCtoPST } from "@/lib/formatters";

const actions = {
  async list({ commit }, { dataType, dataTypeId, serviceAreaId }) {
    const auditLog = await auditLogApi.list(dataType, dataTypeId, serviceAreaId);
    commit("setAuditLog", auditLog.data);
  },
  async fetchReleaseNote({ commit }, releaseNoteId) {
    const log = await auditLogApi.releaseNote(releaseNoteId);

    commit("setReleaseNote", log);
  },
  async fetchServiceArea({ commit }, serviceAreaId) {
    const log = await auditLogApi.serviceArea(serviceAreaId);

    commit("setServiceArea", log);
  },
  async fetchApplicationAdminHistory({ commit }, serviceAreaId) {
    // Optimized endpoint that returns all application admin updates
    // Used by Application Administration page for change history display
    const history = await auditLogApi.applicationAdminHistory(serviceAreaId);

    commit("setApplicationAdminHistory", history);
  },
  async fetchLastApplicationAdminUpdate({ commit }, serviceAreaId) {
    // Optimized endpoint that returns only the most recent application admin update
    // Used by Organization Settings page for "Last updated" date display
    const lastUpdate = await auditLogApi.lastApplicationAdminUpdate(serviceAreaId);

    commit("setLastApplicationAdminUpdate", lastUpdate);
  },
  async fetchTag({ commit }, tagId) {
    const log = await auditLogApi.tag(tagId);

    commit("setTag", log);
  },
  async fetchTestPlan({ commit }, { releaseNoteId, serviceAreaId }) {
    const log = await auditLogApi.testPlan(releaseNoteId, serviceAreaId);

    commit("setTestPlan", log);
  },
};

const mutations = {
  setAuditLog(state, list) {
    state.list = list;
  },
  setReleaseNote(state, log) {
    state.releaseNote = log;
  },
  setServiceArea(state, log) {
    state.serviceArea = log;
  },
  setApplicationAdminHistory(state, history) {
    state.applicationAdminHistory = history;
  },
  setLastApplicationAdminUpdate(state, update) {
    state.lastApplicationAdminUpdate = update;
  },
  setTag(state, log) {
    state.tag = log;
  },
  setTestPlan(state, log) {
    state.testPlan = log;
  },
};

const getters = {
  getApplicationAdminLastUpdatedDate(state) {
    // Optimized getter - uses pre-filtered server data
    // Returns formatted date of most recent application admin update
    // Checks both sources: lastApplicationAdminUpdate (Organization Settings)
    // and applicationAdminHistory[0] (Application Admin - history is sorted DESC)
    const lastUpdate =
      state.lastApplicationAdminUpdate || (state.applicationAdminHistory && state.applicationAdminHistory[0]);
    return lastUpdate ? formatUTCtoPST(lastUpdate.created) : null;
  },
  getExcludedApplicationListLastUpdate(state) {
    // Returns the last application admin update object
    // Used for getting detailed update information
    // Checks both sources: lastApplicationAdminUpdate or first item from history
    return state.lastApplicationAdminUpdate || (state.applicationAdminHistory && state.applicationAdminHistory[0]);
  },
  getApplicationAdminHistory(state) {
    // Returns all application admin updates for change history display
    return state.applicationAdminHistory || [];
  },
};

const state = {
  list: [],
  releaseNote: null,
  serviceArea: null,
  applicationAdminHistory: [],
  lastApplicationAdminUpdate: null,
  tag: null,
  testPlan: null,
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
